import { render, staticRenderFns } from "./ExciseDORLicReturnsParams.vue?vue&type=template&id=31af65d8&"
import script from "./ExciseDORLicReturnsParams.vue?vue&type=script&lang=js&"
export * from "./ExciseDORLicReturnsParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports